import { type ReactNode } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useLocation } from "react-router";
import AuthService from "@/core/services/Auth.service";
import { isPublicAuthRoute } from "@/auth/publicAuthRoutes";
import { useAuth } from "@/hooks/useAuth";
import {
  useDismissInitialLoaderWhen,
  useShowInitialLoader,
} from "@/providers/AppInitialLoaderProvider";

interface AuthCheckProps {
  children: ReactNode;
}

const AuthCheck = ({ children }: AuthCheckProps) => {
  const { isLoading, getAccessTokenSilently } = useAuth0();
  const { logout } = useAuth();
  const { pathname } = useLocation();
  const isPublicRoute = isPublicAuthRoute(pathname);

  useDismissInitialLoaderWhen(isPublicRoute);
  useShowInitialLoader(isLoading && !isPublicRoute);

  if (!isLoading) {
    const auth = AuthService.getInstance();
    auth.setAccessTokenSilentlyFunction(getAccessTokenSilently);
    auth.setLogoutHandler(logout);
  }

  if (isLoading && !isPublicRoute) {
    return null;
  }

  return <>{children}</>;
};

export default AuthCheck;
